import { render, staticRenderFns } from "./CrInstagramDestination.vue?vue&type=template&id=0cd1d7e6&"
import script from "./CrInstagramDestination.vue?vue&type=script&lang=js&"
export * from "./CrInstagramDestination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports